import { ANALYTICS } from '@profile-ui-mono/utilities/constants/analytics';
import { adpAnalyticsEvents } from '@profile-ui-mono/utilities/constants/adpAnalyticsEvents';
import { sendLog } from '@profile-ui/shared-components';

const getAnalyticEvent = (pageName = '', eventType = ANALYTICS.EVENT_PAGE_VIEW) => {
  const trackName =
    eventType === ANALYTICS.EVENT_PAGE_VIEW
      ? 'TRACK_ARTIFICIAL_PAGEVIEW'
      : 'TRACK_LINK_EVENT';
  const page = pageName === '' ? 'home' : pageName;

  return ANALYTICS[trackName][page];
};

/**
 * Handles ADP analytics tracking for side nav navigation.
 *
 * @param {string} pageName - The page name from the nav click (e.g., 'personalinfo', 'security', 'settings')
 * @param {object} [adp] - Optional ADP analytics instance from useAdpAnalytics()
 */
const handleAnalyticsSideNav = (pageName, adp) => {
  if (!adp) {
    const env = window.$profileEnvVars?.REACT_APP_STAGE;
    if (env && env !== 'dev') {
      sendLog(
        new Error('ADP analytics not ready'),
        'Chassis ADP tracking skipped — SDK not initialized yet',
        'handleAnalyticsSideNav'
      );
    }
    return;
  }

  try {
    const page = pageName === '' ? 'home' : pageName;

    adp.track(adpAnalyticsEvents.CLICK_COMPONENT, {
      id: `chassis_nav-${page}`,
      name: `Side Nav - ${page}`,
      type: 'Link',
      attributes: {
        section: 'utilitynav',
        page,
      },
    });

    adp.track(adpAnalyticsEvents.USER_VIEW, {
      id: `chassis_page-${page}`,
      name: getAnalyticEvent(pageName, ANALYTICS.EVENT_PAGE_VIEW),
      type: 'page',
    });
  } catch (error) {
    sendLog(error, 'Chassis ADP tracking error', 'handleAnalyticsSideNav');
  }
};

export { handleAnalyticsSideNav };
